import orderList from "../components/orders/orderList"
import { createMaterialTopTabNavigator } from "@react-navigation/material-top-tabs"
import CommonHeader from "../shared/commonComponents/commonHeader"
import { appColors, appFonts, fontSize } from "../themes/appTheme"
import { RouteProp, useRoute } from "@react-navigation/native"


export type customerIdType = {
    type: { customerId: number }
}
const OrderTab = () => {
    const Order = createMaterialTopTabNavigator()
    const Route = useRoute<RouteProp<customerIdType, "type">>();
    return (
        <>
            <CommonHeader headerName={"Order List"} />
            <Order.Navigator
                // initialParams only apply on mount; remount when the customer filter changes
                key={`orders-${Route?.params?.customerId ?? 'all'}`}
                backBehavior='none'
                initialRouteName="Pos Orders"
                screenOptions={{
                    tabBarLabelStyle: { fontSize: fontSize.largerFontSize, fontFamily: appFonts.bold, textTransform: 'capitalize' },
                    tabBarIndicatorStyle: { backgroundColor: appColors.primary },
                    tabBarActiveTintColor: appColors.primary,
                    tabBarInactiveTintColor: appColors.lightFontColor,
                    tabBarAndroidRipple: { borderless: false },
                }}
            >
                <Order.Screen component={orderList} name="Pos Orders" initialParams={{ customerId: Route?.params?.customerId, isPos: true }} />
                <Order.Screen component={orderList} name="Online Orders" initialParams={{ customerId: Route?.params?.customerId, isPos: false }} />
            </Order.Navigator>
        </>
    )
}

export default OrderTab